import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Phone, Lock, Menu, X } from "lucide-react";

const LINKS = [
  { href: "#services", label: "Services" },
  { href: "#work", label: "Our Work" },
  { href: "#reviews", label: "Reviews" },
  { href: "#quote", label: "Free Quote" },
];

export default function Nav({ content }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-ink/85 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3" data-testid="nav-brand-logo">
          <img src="/logo.png" alt={content.business_name} className="h-11 w-auto rounded-lg bg-white p-1" />
          <div className="hidden sm:block leading-tight">
            <p className="font-display font-bold tracking-tight text-sm">{content.business_name}</p>
            <p className="font-mono text-[10px] tracking-[0.25em] text-sky uppercase">{content.hero_overline}</p>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
               className="text-sm text-slate-300 hover:text-sky transition-colors duration-200">
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a href={`tel:${(content.phone || "").replace(/\D/g, "")}`} data-testid="nav-phone-cta"
             className="hidden sm:inline-flex items-center gap-2 rounded-full bg-royal px-5 py-2.5 text-sm font-semibold hover:bg-royalhover transition-colors duration-200">
            <Phone className="h-4 w-4" />
            {content.phone}
          </a>
          <Link to="/admin/login" data-testid="nav-admin-link" aria-label="Owner login"
                className="p-2.5 rounded-full border border-white/10 text-slate-400 hover:text-sky hover:border-sky/40 transition-colors duration-200">
            <Lock className="h-4 w-4" />
          </Link>
          <button className="md:hidden p-2 text-slate-300" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-ink/95 backdrop-blur-xl border-t border-white/10 px-6 py-4 flex flex-col gap-4">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="text-slate-200 text-sm">
              {l.label}
            </a>
          ))}
          <a href={`tel:${(content.phone || "").replace(/\D/g, "")}`} className="inline-flex items-center gap-2 text-sky font-semibold text-sm">
            <Phone className="h-4 w-4" /> {content.phone}
          </a>
        </div>
      )}
    </header>
  );
}
